<template>
    <!-- 行高设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="行高"> 
        <el-radio-group v-model="lineHeight" size="small">
          <el-radio-button v-for="(item,index) in lineHeightConfigList"
                          :key="index" 
                          :label="item.label">{{item.value}}</el-radio-button>
        </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入斜体配置文件
import { lineHeightConfigList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  data () {
    return {
      // 斜体配置
      lineHeightConfigList
    }
  },
  computed: {
    /** @name 行高
     *  @description 将 lineHeight 字段映射到当前 lineHeight 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      lineHeight: { 
        parent: i => i.renderOption,
        attr: "lineHeight"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderLineHeight.vue